// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3e39696b","732":"1edf3444","900":"81752baf","977":"ecbec363"}[chunkId] + ".chunk.js";
};